<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <h5 class="mb-0">SAP Orders</h5>
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <router-link to="/sap_equipment_logs" class="btn btn-info btn-sm">
                                    <i class="fas fa-list-alt"></i> SAP Equipment Logs
                                </router-link>
                                <router-link to="/sent_report_logs" class="btn btn-primary btn-sm">
                                    <i class="fas fa-paper-plane"></i> Sent Orders
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row gutters">
                                <div class="col-sm-2">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">From Date</div>
                                        <input class="form-control form-control-sm" type="date" v-model="meta.from_date" />
                                        <span v-if="errors.from_date" class="invalid-feedback">{{ errors.from_date[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">To Date</div>
                                        <input class="form-control form-control-sm" type="date" v-model="meta.to_date" />
                                        <span v-if="errors.to_date" class="invalid-feedback">{{ errors.to_date[0] }}</span>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <div class="input-group field-wrapper">
                                        <input class="form-control" type="text" placeholder="Type here and press enter to search" v-model="meta.search" @keyup.enter="search" />
                                        <span class="input-group-text">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <button type="submit" v-if="status" @click="search" class="btn btn-primary btn-block btnn">
                                        Search
                                    </button>
                                    <button type="submit" v-if="status" @click="reset" class="btn btn-danger btn-block btnn">
                                        Reset
                                    </button>
                                </div>
                            </div>
                            
                            <div class="table-responsive tabletop">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th @click="sort('job_no')">
                                                Job No
                                                <span>
                                                    <i v-if="meta.field == 'job_no' && meta.order_by == 'asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field == 'job_no' && meta.order_by == 'desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('date_time')">
                                                Date Time
                                                <span>
                                                    <i v-if="meta.field == 'date_time' && meta.order_by == 'asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field == 'date_time' && meta.order_by == 'desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('file_path')">
                                                File Path
                                                <span>
                                                    <i v-if="meta.field == 'file_path' && meta.order_by == 'asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field == 'file_path' && meta.order_by == 'desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="sap_logs.length == 0">
                                            <td colspan="5" class="text-center">No records found</td>
                                        </tr>
                                        <tr v-for="(user_log, key) in sap_logs" :key="key">
                                            <td>{{ meta.from + key }}</td>
                                            <td>{{ user_log?.job_no }}</td>
                                            <td>{{ user_log.date_time }}</td>
                                            <td>{{ user_log.file_path }}</td>
                                            <td>
                                                <router-link
                                                    :to="`/sap_report_logs/${user_log.order_id}`"
                                                    class="cursor-pointer text-primary mx-2"
                                                    style="font-size: 1rem;"
                                                    title="View Details">
                                                    <i class="fas fa-eye"></i>
                                                </router-link>
                                                <a
                                                    v-if="$store.getters.user?.role?.role_name === 'Super Admin'"
                                                    download
                                                    class="cursor-pointer text-success mx-2"
                                                    style="font-size: 1rem;"
                                                    title="Download File"
                                                    @click="downloadOrders(user_log)">
                                                    <i class="fas fa-download"></i>
                                                </a>
                                                <a
                                                    v-if="$store.getters.user?.role?.role_name === 'Super Admin'"
                                                    :href="user_log.log_file_url"
                                                    target="_blank"
                                                    class="cursor-pointer text-success mx-2"
                                                    title="Log File">
                                                    <i class="fas fa-file-alt fa-lg"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end row">
                                    <div class="col-sm-2">
                                        <select class="form-control" v-model="meta.per_page" @change="onPerPageChange">
                                            <option>10</option>
                                            <option>15</option>
                                            <option>20</option>
                                            <option>25</option>
                                            <option>30</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-10">
                                        <Pagination class="pagination pagination-sm" :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.currentPage" @pagechanged="onPageChange" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .btnn {
        margin-top: 0.5rem;
    }
    .table-responsive {
        max-height: 300px;
        overflow-y: auto;
        overflow-x: auto;
    }
    .table th,
    .table td {
        white-space: nowrap;
        vertical-align: middle;
    }
    .equipment-row {
        background-color: #e9ecef;
        font-weight: bold;
    }
    .check-row {
        background-color: #f8f9fa;
    }
    .modal-fullscreen {
        width: 100vw;
        max-width: 100%;
        height: 100vh;
        margin: 0;
    }
    .modal-fullscreen .modal-content {
        height: 100%;
        border-radius: 0;
    }
    .modal-fullscreen .modal-body {
        overflow-y: auto;
    }
</style>

<script>
    import Pagination from "@/components/Pagination.vue";

    export default {
        components: { Pagination },
        data() {
            return {
                status: true,
                errors: [],
                sap_logs: [],
                meta: {
                    from_date: "",
                    to_date: "",
                    search: "",
                    order_by: "desc",
                    field: "order_id",
                    per_page: 10,
                    totalRows: 0,
                    currentPage: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                    plant_id: this.$store.getters.user.plant_id,
                },
                selectedLog: null,
                modalInstance: null,
            };
        },
        mounted() {
            this.$store.commit("setModule", "UserLog");
            this.index();
        },
        methods: {
            index() {
                let vm = this;
                let uri = "paginateSAPOrders?page=" + vm.meta.currentPage +
                    "&search=" + vm.meta.search + "&order_by=" + vm.meta.order_by + "&field=" + vm.meta.field +
                    "&per_page=" + vm.meta.per_page + "&from_date=" + vm.meta.from_date + "&to_date=" + vm.meta.to_date;
                vm.$store.dispatch("post", { uri: uri })
                    .then(function (response) {
                        vm.sap_logs = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            downloadOrders(user_log) {
                let vm = this;
                let uri = "downloadOrders?order_id=" + user_log.order_id;
                vm.$store.dispatch("get", { uri: uri, responseType: 'blob' })
                    .then(function (response) {
                        const blob = new Blob([response.data], { type: 'text/csv' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `DigiCheck_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors || ['Failed to download file'];
                        vm.$store.dispatch("error", error.response.data.message || 'An error occurred while downloading the file');
                    });
            },
            reset() {
                let vm = this;
                vm.meta.from_date = "";
                vm.meta.to_date = "";
                vm.meta.search = "";
                vm.meta.currentPage = 1;
                vm.$store.commit("setPage", 1);
                vm.$store.commit("setMeta", null);
                vm.index();
            },
            onPageChange(page) {
                this.meta.currentPage = page;
                this.index();
            },
            onPerPageChange() {
                this.meta.currentPage = 1;
                this.index();
            },
            sort(field) {
                this.meta.field = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            search() {
                let vm = this;
                vm.meta.currentPage = 1;
                vm.$store.commit("setMeta", vm.meta);
                vm.$store.commit("setPage", vm.meta.currentPage);
                vm.index();
            },
        },
    };
</script>